import { render } from "./FormAttribute.vue?vue&type=template&id=1ce0946e"
import script from "./FormAttribute.vue?vue&type=script&lang=js"
export * from "./FormAttribute.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__